import React from 'react'
import Layout from '../../components/layout/Layout'
import AllProductsTable from '../../elements/tables/ecomm/AllProductsTable'

export default function AllProducts() {
  return (
    <div>
      <Layout>
        <AllProductsTable />
      </Layout>
    </div>
  )
}
